import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
export default {
  props: {
    value: Number,
    confirm: Function,
    cancel: Function,
    dialog: Boolean,
    paymentStatus: String,
    paymentIdType: Number,
    reference: String
  },
  data: function data() {
    return {
      errorOccured: false,
      paymentType: null,
      selectedStatus: null,
      paymentReference: null,
      interval: null,
      timeLeft: 0,
      validating: false,
      paymentDate: new Date().formatForDatePickerDays(),
      resolve: null,
      reject: null,
      options: {
        color: "primary",
        width: 850,
        zIndex: 2000
      },
      dateMenu: null
    };
  },
  methods: {
    confirmClientChange: function confirmClientChange() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.validating = true;
              _this = _this2;
              _context.next = 4;
              return _this2.confirm().then(function () {
                _this.validating = false;
              }).catch(function (e) {
                var _e$response;
                if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && _e$response.data) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "warning"
                  });
                }
                _this.validating = false;
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    internalCancel: function internalCancel() {
      this.selectedStatus = null;
      this.errorOccured = false;
      this.cancel();
    }
  }
};